import ContactForm from './ContactForm';
import projectsData from './projectsData';
import { useEffect, useState } from 'react';
import '../styles/projects.css';
import '../styles/sectionShared.css';

const PROJECTS_PATH = '/projekt';

const getViewModeFromPath = () => (window.location.pathname === PROJECTS_PATH ? 'full' : 'preview');

function ProjectsSection() {
  const [viewMode, setViewMode] = useState(() => getViewModeFromPath());

  useEffect(() => {
    const handlePopState = () => {
      setViewMode(getViewModeFromPath());
    };

    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  const visibleProjects = viewMode === 'preview' ? projectsData.slice(0, 2) : projectsData;

  const showAllProjects = () => {
    if (window.location.pathname !== PROJECTS_PATH) {
      window.history.pushState({}, '', PROJECTS_PATH);
    }
    setViewMode('full');
  };

  const showPreview = () => {
    if (window.location.pathname === PROJECTS_PATH) {
      window.history.pushState({}, '', '/');
    }
    setViewMode('preview');
  };

  if (viewMode === 'full') {
    return (
      <>
        <section className="projects-fullscreen" id="projekt" aria-labelledby="projects-full-heading">
          <button className="projects-back-button-fixed" onClick={showPreview} type="button">
            Tillbaka
          </button>

          <div className="projects-fullscreen-inner">
            <div className="section-header">
              <p className="section-overline">Projekt</p>
              <h2 id="projects-full-heading">Mina uppdrag</h2>
            </div>

            <div className="projects-list">
              {visibleProjects.map((project) => (
                <article className="project-card" key={project.title}>
                  <figure className="project-media">
                    <img src={project.image} alt={project.title} />
                  </figure>
                  <div className="project-content">
                    <h3>{project.title}</h3>
                    <p>{project.description}</p>

                    {project.review ? (
                      <blockquote>
                        {project.review}
                        {project.reviewer ? <cite> , {project.reviewer}</cite> : null}
                      </blockquote>
                    ) : null}

                    {project.link ? (
                      <a href={project.link} target="_blank" rel="noreferrer">
                        Besök projekt
                      </a>
                    ) : null}
                  </div>
                </article>
              ))}
            </div>

            <div className="projects-fullscreen-contact" aria-labelledby="projects-contact-heading">
              <div className="section-header">
                <p className="section-overline">Kontakt</p>
                <h2 id="projects-contact-heading">Har du nåt roligt på gång?</h2>
                <p className="projects-contact-lead">
                  Hör gärna av dig om du har en idé du vill bolla, något du funderar på eller bara lust att
                  prata lite. Jag tycker det är kul att höra vad andra håller på med.
                </p>
              </div>
              <ContactForm />
            </div>
          </div>
        </section>
      </>
    );
  }

  return (
    <section className="projects-section" id="projekt" aria-labelledby="projects-heading">
      <div className="section-header">
        <p className="section-overline">Projekt</p>
        <h2 id="projects-heading">Mina uppdrag</h2>
      </div>

      <div className="projects-list">
        {visibleProjects.map((project) => (
          <article className="project-card" key={project.title}>
            <figure className="project-media">
              <img src={project.image} alt={project.title} />
            </figure>
            <div className="project-content">
              <h3>{project.title}</h3>
              <p>{project.description}</p>

              {project.review ? (
                <blockquote>
                  {project.review}
                  {project.reviewer ? <cite> , {project.reviewer}</cite> : null}
                </blockquote>
              ) : null}

              {project.link ? (
                <a href={project.link} target="_blank" rel="noreferrer">
                  Besök projekt
                </a>
              ) : null}
            </div>
          </article>
        ))}
      </div>

      <div className="projects-cta-block">
        <p className="projects-cta-label">Fler kundcase och hela texter</p>
        <button className="projects-cta-button" onClick={showAllProjects} type="button">
          Se resten
        </button>
        <p className="projects-cta-hint">Här ovanför ser du två exempel. Klicka för att läsa alla uppdrag.</p>
      </div>
    </section>
  );
}

export default ProjectsSection;
